import { RouteRecordRaw } from 'vue-router';
import { enactRoutes } from '../enactRoutes.ts';
import { deltaGptRoutes, getResearchRoutes } from '../deltaGptRoutes.ts';
import { SectionRouteNames } from './sectionRouteNames.ts';

export const powerAndStorageRoutes: Record<string, RouteRecordRaw> = {
    home: {
        path: '',
        name: `${SectionRouteNames.powerAndStorage}Home`,
        components: {
            default: () => import('@/views/sectionViews/powerAndStorage/PowerAndStorageHomeView.vue'),
        },
        meta: {
            headName: 'Power & Storage Home',
            displayTitle: 'Home',
        },
    },
    research: {
        path: 'research',
        name: `${SectionRouteNames.powerAndStorage}Research`,
        redirect: { name: `${SectionRouteNames.powerAndStorage}_${deltaGptRoutes.documentList.name as string}` },
        children: getResearchRoutes(SectionRouteNames.powerAndStorage),
        meta: {
            headName: 'Research',
            searchMeta: {
                tags: ['research'],
            },
        },
    },
    enact: {
        path: 'enact',
        name: `${SectionRouteNames.powerAndStorage}Enact`,
        children: [...Object.values(enactRoutes)],
        redirect: { name: 'benchmarks' },
        meta: {
            headName: 'Enact',
            showChildrenInNavbar: true,
            searchMeta: {
                tags: ['enact'],
            },
            showChildrenInNavDropdown: true,
        },
    },
};
